// import Vue from 'vue';

const state = {
  // [clientId]: { dashboardCards: {}, dashboardData: {}, dashboardCharts: {}, lastFetchedAt: null }
  clientDashboards: {},
  dashboardsCleanUpAt: null
}

const getters = {
  clientDashboards: (state) => (clientId) => {
    const dashboards = state.clientDashboards[clientId]
    if (!dashboards) return {
      dashboardCards: { Quotes: "0", Orders: "0", ServiceCalls: "0", ServiceContracts: "0", Invoices: "0", OverdueInvoice: "N" },
      dashboardData: {},
      dashboardCharts: {},
      lastFetchedAt: null
    }
    return dashboards
  }
}

const mutations = {
  clearClientDashboards(state, clientId) {
    if (state.clientDashboards[clientId]) {
      delete state.clientDashboards[clientId]
    }
  },
  setClientDashboards(state, { clientId, data }) {
    state.clientDashboards = {
      ...state.clientDashboards,
      [clientId]: data
    }
  },
  clearAllDashboards(state) {
    state.clientDashboards = {}
  }
}

const actions = {
  cleanupExpiredDashboards({ state, commit }) {
    const TWO_HOURS = 2 * 60 * 60 * 1000
    if (state.lastDashboardsCleanUp && new Date().getTime() - state.dashboardsCleanUpAt < TWO_HOURS) return // only run once every 2 hours
    if (Object.keys(state.clientDashboards).length === 0) return

    const now = Date.now()
    const EXPIRATION_TIME_BY_DASHBOARD = TWO_HOURS
    const dashboards = state.clientDashboards

    for (const clientId in dashboards) {
      const dashboard = dashboards[clientId]
      if (!dashboard || !dashboard.lastFetchedAt) continue

      const fetchedAtTime = new Date(dashboard.lastFetchedAt).getTime()
      const isExpired = now - fetchedAtTime > EXPIRATION_TIME_BY_DASHBOARD

      if (isExpired) commit('clearClientDashboards', clientId)
    }

    state.dashboardsCleanUpAt = now
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
